import { OrderStatus } from '../models/Order';

const translateOrderStatus = (status: OrderStatus) => {
  switch (status) {
    case OrderStatus.PENDING:
      return 'Oczekujące';
    case OrderStatus.COMPLETED:
      return 'Zrealizowane';
    case OrderStatus.CANCELLED:
      return 'Anulowane';
    case OrderStatus.IN_PROGRESS:
      return 'W trakcie realizacji';
    default:
      return status;
  }
};

export default translateOrderStatus;
